// extracted by mini-css-extract-plugin
module.exports = {"alfredFooterRoot":"t7CEHEFK","hidden":"fIE_kI2V","fixed":"_7jIqToA0","sticky":"xiPJrNlC","inputRegion":"L5kqDJiS"};